import { getEnvConfig } from 'getEnvConfig';
import React from 'react';

export const GrafanaIframe: React.FC = () => {
    return <iframe className="w-full h-full" src={getEnvConfig.GRAFANA_REPORT_URL}></iframe>;
};
